export default __webpack_public_path__ + "static/media/staticblood.7e5bfefd.png";